/* src/app/admin-dashboard/special-prices/special-prices.component.css */
::ng-deep app-table-standard-layout .special-price-row {
  background-color: #f1d475 !important;
}
/*# sourceMappingURL=special-prices.component.css.map */
